export default "__VITE_ASSET__Bq0akw_A__"